import React from 'react';
import { parseTexToHtml, TexParseOptions } from '@/utils/tex-parser';
import { sanitizeTexHtml } from '@/lib/security/sanitization';
import { cn } from '@/lib/utils';

interface TexTextProps {
  children: string;
  className?: string;
  options?: TexParseOptions;
  /**
   * `inherit` (default) keeps KaTeX at the surrounding font size, which is what
   * we want inside headings and body copy alike.
   */
  variant?: 'inherit' | 'default';
}

/**
 * Renders TeX-formatted text as HTML. Text-level LaTeX is normalised by the
 * parser, real math is typeset with KaTeX, and the result is sanitized before
 * it is injected.
 */
const TexText: React.FC<TexTextProps> = ({
  children,
  className = '',
  options = {},
  variant = 'inherit',
}) => {
  const parsedHtml = React.useMemo(() => {
    const html = parseTexToHtml(children, options);
    return sanitizeTexHtml(html);
  }, [children, options]);

  return (
    <span
      className={cn('tex-content', variant === 'inherit' && 'tex-inherit', className)}
      dangerouslySetInnerHTML={{ __html: parsedHtml }}
    />
  );
};

export default TexText;
